import {Node, NodeType} from "../../../model/Graph";
import {getSingleTargetOfType} from "../node/get-single-node-of-type";

export const isDddActionUi = (ui: Node): boolean => {
  return !!getSingleTargetOfType(ui, NodeType.command);
}
